module.exports = __webpack_public_path__ + "img/icon-come-funziona-trova.49fcaa09.svg";